/**
 * @file Automatically generated by barrelsby.
 */
export * from './already-deleted-page/index';
export * from './lock-error-page/index';
export * from './no-permission/index';
export * from './successfully-deleted-page/index';
//# sourceMappingURL=index.js.map